import React from 'react'
import "./TPMS_1.css"
function TPMS_1() {
  return (
    <>
    <div>
        <div className="toll-hero">
        {/* <img src="product-img/product4.jpg" alt="toll plaza" /> */}
        <video  className="toll-video" autoPlay loop muted playsInline>
          <source src="video/TPMS_video.mp4" type="video/mp4"/>
        </video>
        <div className="toll-overlay">
          <h1 data-aos="fade-up" className='fw-bold text-center transforming'>Transforming Toll Operations with <br></br><span className='ai-color'>AI-Powered TPMS</span> </h1>
          <p className='gradient-col1'>
 Real-Time Monitoring | 100% Transparency | Fraud Prevention | Smart 
Analytics</p>
        </div>
      </div>
    </div>
    
    </>
  )
}

export default TPMS_1;
